__turbopack_context__.v({
  "active": "_7LnZFG_active",
  "chevron": "_7LnZFG_chevron",
  "codeBlockV2": "_7LnZFG_codeBlockV2",
  "codeContent": "_7LnZFG_codeContent",
  "dark": "_7LnZFG_dark",
  "dropdown": "_7LnZFG_dropdown",
  "dropdownItem": "_7LnZFG_dropdownItem",
  "header": "_7LnZFG_header",
  "headerControls": "_7LnZFG_headerControls",
  "headerCopyButton": "_7LnZFG_headerCopyButton",
  "headerLeft": "_7LnZFG_headerLeft",
  "headerThemeButton": "_7LnZFG_headerThemeButton",
  "languageButton": "_7LnZFG_languageButton",
  "languageSwitcher": "_7LnZFG_languageSwitcher",
  "light": "_7LnZFG_light",
  "sdkNotice": "_7LnZFG_sdkNotice",
  "title": "_7LnZFG_title",
});
